import { c as _c } from "react/compiler-runtime";
import { GROUP_CITIES_QUERY_URL } from "@website/accommodation-ui/constant/addresses-group";
import { CityType } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/types";
import { fetcher, FetcherResponseType } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
export const useQueryCities = query => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== query) {
    t0 = ["city-query", query];
    t1 = () => fetcher({
      url: `${GROUP_CITIES_QUERY_URL}?q=${query}`
    }).then(_temp);
    $[0] = query;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = query.length > 1;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const response_0 = useFetcher(t3);
  return response_0;
};
function _temp(response) {
  return response.data;
}